import React from "react";
import { APP_RELEASE } from "@/config/appRelease";

/**
 * <PrintFooter /> — Footer istituzionale unificato per le anteprime
 * di stampa e le preview in-app del Design System (Storybook, dialog
 * di anteprima PDF). Mantiene lo stesso identico layout usato dalla
 * utility `buildPrintDocument` in `src/utils/printLayout.js` e dai
 * generatori ReportLab del backend.
 *
 * Contenuto (3 colonne):
 *   [Sinistra]  Stampato il DD/MM/YYYY HH:mm
 *   [Centro]    Suite · Banca dati · vX.Y.Z (data)
 *   [Destra]    Pagina N (o "N / M" in stampa reale)
 *
 * Props:
 *   - printedAt: string opzionale (default = now, formattato it-IT)
 *   - pageLabel: string opzionale (default "Pagina 1 / 1")
 *   - accent:    "green" (default) | "muted" — colore linea/testo
 *   - compact:   boolean — dimensione font ridotta per micro-anteprime
 */
export function PrintFooter({
  printedAt,
  pageLabel = "Pagina 1 / 1",
  accent = "green",
  compact = false,
  className = "",
  style = {},
  ...rest
}) {
  const ts = printedAt || formatNow();
  const borderColor =
    accent === "green" ? "var(--gis-green)" : "#cbd5e1";
  const strongColor =
    accent === "green" ? "var(--gis-green)" : "#0f172a";

  return (
    <div
      className={`gis-body flex items-center justify-between gap-3 border-t pt-1 ${className}`}
      style={{
        borderColor,
        fontSize: compact ? 7 : 8,
        color: "#64748b",
        ...style,
      }}
      data-testid="print-footer"
      {...rest}
    >
      <span data-testid="print-footer-date">Stampato il {ts}</span>
      <span data-testid="print-footer-brand">
        <b style={{ color: strongColor }}>{APP_RELEASE.suiteName}</b>
        {" · "}Banca dati: <b style={{ color: strongColor }}>{APP_RELEASE.dataSource}</b>
        {" · "}<b style={{ color: strongColor }}>v{APP_RELEASE.version}</b>
        {" "}({APP_RELEASE.updatedAt})
      </span>
      <span data-testid="print-footer-page">{pageLabel}</span>
    </div>
  );
}

function formatNow() {
  try {
    return new Date().toLocaleString("it-IT", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return "";
  }
}

export default PrintFooter;

